import EmailInfoBlock from './Component';

export default EmailInfoBlock;